import React from 'react';
import { Helmet } from 'react-helmet';
import { Translation } from 'react-i18next';
import { matchPath } from "react-router-dom";
import Button from '../../components/button/button';
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import i18n, { toRoute } from "../../i18n";
import AppAccordion from './components/AppAccordion';
import JobCard from './components/JobCard';
import jobDb from './localDB/localDB';
import { en as jobEn, th as jobTh } from './localDB/localDB_detail';
import './styles/detail.css';
import {FacebookShareButton,FacebookIcon} from "react-share";

const styles = {
  line_breaker: {
    height: 0.5,
    backgroundColor: '#d8d8d8',
    marginBottom: 36
  },
  subtitle: {
    fontFamily: 'Prompt',
    color: '#f9b13d',
    fontSize: 14
  },
}

export default class CareerDetail extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      id: null,
      job: {}
    }
  }

  componentDidMount() {
    const route = matchPath(this.props.location.pathname, { path: '/:lang?/career/:id' })
    if (route?.params?.id) {
      const id = Number(route.params.id)
      const job = jobDb.job_openings.find(it => it.id === id)
      this.setState({ id, job })
    }
  }

  render() {
    const { job } = this.state
    const desc = (i18n.language === 'en' ? jobEn : jobTh)
    const { job_desc, similar_jobs } = desc

    let path = 'https://silverman.app/career'

    const route = matchPath(this.props.location.pathname, { path: '/:lang?/career/:id' })
    const paramsId = Number(route.params.id)

    if(this.state.id !== null){
      if(this.state.id !== paramsId){
         window.location.reload()
         window.history.scrollRestoration = 'manual'
        // document.documentElement.scrollTop = document.root.scrollTop = 300;
      }
    }
   
    return (
      <Translation ns={['translation', 'career']}>
        {t => (
          <>
            <Helmet>
              <title>{t('career:title')}</title>
              <meta name="description" content={t('career:title')} />
              <meta name="keywords" content={t('career:title')} />
              <link rel="canonical" href="https://silverman.app/career" />
            </Helmet>

            <Image src={asset('/images/career/group-423.svg')} alt="bg" className="bg-job-desc-container" />

            <div className="job-desc-container py-5">
              <div className="job-desc-title-container">
                <p className="job-desc-title">{job?.title || 'Unkown'}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={styles.subtitle}>{job?.title || '-'}</p>
                  <p style={{ marginLeft: 15, marginRight: 15, color: '#676767' }}>|</p>
                  <p style={{ fontFamily: 'Prompt', color: '#676767', fontSize: 12, alignSelf: 'center' }}>{job?.status || 'Full time'}</p>
                </div>
              </div>
              {/* accordion */}
              <div className="job-desc-accordion">
                <div style={{ marginBottom: 90 }}>
                  {/* first screen */}
                  {job_desc.map(desc => (
                    <AppAccordion key={desc.title} data={desc} />
                  ))}
                </div>
                <div className='row'>
                   <div className='col-md-6'>
                   <Button asLink={true} to={toRoute('/become-partner')} title="Apply this jobs" height={45} className="button_style" />
                   </div>
                  <div className='col-md-6 defail-fb-shared'>
                  <FacebookShareButton  url={`${path}/${job?.id}`} >
                    <FacebookIcon size={32} round={true} />
                  </FacebookShareButton>
                  </div> 
                </div>
              </div>
              {/* second screen */}
              <div style={{ textAlign: 'center', alignItems: 'center' }}>
                <div style={styles.line_breaker} />
                {/* job cards */}
                <h3>Similar Jobs</h3>
                <div className="job_list" >
                  <JobCard data={similar_jobs[0]} key={similar_jobs[0].title} />
                  <JobCard data={similar_jobs[1]} key={similar_jobs[1].title} />
                  <JobCard data={similar_jobs[2]} key={similar_jobs[2].title} />
                </div>
              </div>
            </div>
          </>
        )}
      </Translation>
    )
  }
}
